export * as config from './config';

export {
  mainPageOpen,
  submitSearchForm,
  blogClick,
  switchCitiesClick,
  myTicketsPageOpen,
  mainScroll,
  multiTripToggleClick,
  multiTripAutoExit,
  multiTripInfoOpen,
  multiTripSubmitValidationFailed,
  animatedFlowAssigned,
  animatedFlowFieldOpen,
  animatedFlowFieldCommit,
  animatedFlowDismissed,
  type SubmitSearchFormParams,
} from './main-page';

export type {
  DetailsPageOpenParams,
  PayButtonClickParams,
  SelectFareFamilyParams,
  SearchResultCardCashbackPriceClickParams,
  JjDetailsBannerShowParams,
} from './types';

export {
  searchPageOpen,
  priceCalendarClick,
  filtersClick,
  resetFiltersClick,
  applyFiltersClick,
  sortSeparateClick,
  airlinesSeparateClick,
  timeSeparateClick,
  transfersSeparateClick,
  airlinesSeparateApplied,
  timeSeparateApplied,
  transfersSeparateApplied,
  directSeparateClick,
  directSeparateApplied,
  changeSortMode,
  directFlightsView,
  directFlightsClick,
  directFlightsShowMore,
  type SearchPageOpenParams,
  openChangeSearchParams,
  priceCalendarShow,
  priceSwipeRight,
  priceSwipeLeft,
  priceCalendarClose,
  priceCalendarOffersShow,
  serpScroll,
  promocodeApplied,
  searchResultCardCashbackPriceClick,
} from './search-page';
export {
  detailsPageOpen,
  detailsPageContinue,
  jjDetailsBannerShow,
} from './details-page';
export {
  trySubmitPassengersData,
  selectSavedPassenger,
  savedPaxListOpen,
  savedPaxEditClick,
  savedPaxSaveClick,
  addNewPaxClick,
  openPassengersDataPage,
  type PassengersDataSubmitProps,
  type SavedPaxListOpenParams,
  type SavedPaxEditClickParams,
  type SavedPaxSaveClickParams,
} from './passenger-data-page';
export {
  bookingSuccess,
  bookingError,
  productsPageOpen,
  type BookingSuccessInfo,
  type ProductsPageOpenParams,
} from './products-page';
export {
  hotOffersScroll,
  hotOffersSearchClick,
  hotOffersAllDatesClick,
  hotOffersOriginCityChange,
  hotOffersPageOpen,
} from './hot-offers';
export {
  quizBannerClick,
  quizPageViewed,
  quizQuestion,
  quizNextQuestion,
  quizFinal,
  takePromocodeClick,
  otherRoutesClick,
} from './quiz';
export {
  fareFamilyPageOpen,
  selectFareFamily,
  continueFareFamily,
} from './fare-family';
export { paymentPageOpen, payButtonClick } from './payment';
export {
  lastSearchesShow,
  lastSearchesClick,
  lastSearchesRemove,
} from './recent-searches';
export {
  specialOfferFriendsShown,
  specialOfferFriendsClicked,
  type SpecialOfferFriendsParams,
} from './special-offers';
